import React from "react";
import svg from "../assets/images/page-not-found.png";
import '../styles/page-not-found.css'

const PageNotFound = () => {
    return (
        <>
            <div className="page-not-found">
                <img src={svg} alt="Page Not Found" />
                <div className="my-5"><a className="btn btn-link " href="/">Back to Home</a></div>
                
            </div>

            
        </>
    );
};

export default PageNotFound;